import type { App, Component } from 'vue'

const baseComponents = import.meta.glob('@/components/base/Base*.vue', { eager: true })

export function registerBaseComponents(app: App): void {
  for (const [path, module] of Object.entries(baseComponents)) {
    const name = path.split('/').pop()!.replace('.vue', '')
    app.component(name, (module as { default: Component }).default)
  }
}
